import {request, serviceUrl} from "@/utils/request";

//根据id获取删除轮显设备数据
export function deleteById(id) {
  return request({
    url: serviceUrl.deviceService + '/alternate/device/deleteById',
    params: {id}
  })
}

//轮显设备列表
export function getList(isShowPointValue) {
  return request({
    url: serviceUrl.deviceService + '/alternate/device/detailList',
    params: {isShowPointValue}
  })
}


//保存轮显设备
export function save(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alternate/device/save',
    data: params
  })
}
//编辑轮显设备
export function update(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alternate/device/update',
    data: params
  })
}
